// extracted by mini-css-extract-plugin
export default {"tableContanier":"TeamProfilePlayersTable_tableContanier__NhE36","tablePlayersList":"TeamProfilePlayersTable_tablePlayersList__9biO-"};